module.exports = {"id":"230218","name":"Fabiano Sonta","rating":"73","photo":"./data/images/photos/1/230218.png","club":{"name":"Atl. Paranaense","logo":"./data/images/clubs/Atl.Paranaense.png"},"positions":["DC","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabianoSonta0.json
// module id = 1337
// module chunks = 0